import { isGlobalworth } from 'config'

enum BookingPaths {
  PARKING_SPOTS = '/booking/parking-spots',
  CONFERENCE_ROOMS = '/booking/conference-rooms',
  DESKS = '/booking/desks',
  LOCKERS = '/booking/lockers',
}

const isBookingPath = (pathname: string) => {
  const paths = Object.values(BookingPaths)

  if (!isGlobalworth) {
    return paths
      .filter(path => path !== BookingPaths.LOCKERS)
      .some(path => pathname.startsWith(path))
  }

  return paths.some(path => pathname.startsWith(path))
}

export { BookingPaths, isBookingPath }
